import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "startpage",
  class: "py-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Nedan visas exempelvis ärenden och tjänster som är relevanta ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-v-h3" }, "Vi önskar alltid dina idéer!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Mina sidor är under ständig utveckling och förfining. Vi vill såklart alltid ha dina idéer samt information om fel uppstår, maila "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:rikard@westro.se" }, "rikard@westro.se")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-v-h3 mt-4" }, "Den här rutan", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Här får du hjälp, tips och information relaterat till den sida du besöker. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "text-v-h3 mt-4" }, "Aktuellt för ditt företag ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Ditt företags aktuella ärenden och händelser visas här. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "text-v-h3 mt-4" }, "Vad behöver du idag?", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Här visas snabblänkar till funktioner och tjänster som kan vara intressanta för ditt företag. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "text-v-h3 mt-4" }, "Företaget", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, " Här finns snabblänkar till sidor med samlad information om ditt företag ", -1)


import { useAuthStore } from '@/stores/authStore'

import startpageCases from '@/components/startpage/startpageCases.vue'
import startpageServices from '@/components/startpage/startpageServices.vue'
import startpageLinks from '@/components/startpage/startpageLinks.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StartpageView',
  props: {
  textClass: {
    type: Object
  },
  columnSizes: {
    type: Object
  },
  paddingClass: {
    type: String
  }
},
  setup(__props) {

const AuthStore = useAuthStore()

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", {
        class: _normalizeClass(__props.textClass?.h1)
      }, " Hej, " + _toDisplayString(_unref(AuthStore).getFirstName) + "!", 3),
      _hoisted_2,
      _createVNode(_component_v_row, { class: "pt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: __props.columnSizes?.[0]
          }, {
            default: _withCtx(() => [
              _createVNode(startpageCases, { textClass: __props.textClass }, null, 8, ["textClass"]),
              _createVNode(startpageServices, { textClass: __props.textClass }, null, 8, ["textClass"])
            ]),
            _: 1
          }, 8, ["cols"]),
          _createVNode(_component_v_col, {
            cols: __props.columnSizes?.[1]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { class: "bg-info pa-4" }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["cols"])
        ]),
        _: 1
      })
    ]),
    _createVNode(startpageLinks, {
      textClass: __props.textClass,
      paddingClass: __props.paddingClass
    }, null, 8, ["textClass", "paddingClass"])
  ], 64))
}
}

})